var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"qrcode",on:{"click":_vm.handleClick}},[_c('appIcon',{attrs:{"name":"qrcode-scan"}}),_c('QRCodeDialog',{ref:"dialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }